import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("gk_auth") !== "1") { setUser(false); setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => { setUser(false); localStorage.removeItem("gk_auth"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, turnstileToken) => {
    const { data } = await api.post("/auth/login", { email, password, turnstile_token: turnstileToken });
    localStorage.setItem("gk_auth", "1");
    setUser(data);
    return data;
  };

  const register = async (name, email, password, turnstileToken) => {
    const { data } = await api.post("/auth/register", { name, email, password, turnstile_token: turnstileToken });
    localStorage.setItem("gk_auth", "1");
    setUser(data);
    return data;
  };

  const googleAuth = async (sessionId) => {
    const { data } = await api.post("/auth/google", { session_id: sessionId });
    localStorage.setItem("gk_auth", "1");
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    localStorage.removeItem("gk_auth");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleAuth, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiError };
